import { buildEmptySecondaryPairForm } from '../address/create-pair-form.js';
import { vendorAddressPairFormSchema, } from './create-pair-form.js';
import { createVendorShippingAndRemitToAddressesInputSchema } from './create-pair-input.js';
export const EMPTY_VENDOR_ADDRESS_PAIR_FORM = buildEmptySecondaryPairForm('remitSameAsShipping', 'remit');
export function toCreateVendorShippingAndRemitToAddressesInput(values, vendorName) {
    const parsed = vendorAddressPairFormSchema.parse(values);
    const remitSameAsShipping = parsed.remitSameAsShipping !== false;
    return createVendorShippingAndRemitToAddressesInputSchema.parse({
        name: vendorName,
        shipping: {
            addressName: parsed.addressName,
            address: parsed.address,
            city: parsed.city ?? null,
            stateId: parsed.stateId ?? null,
            countryId: parsed.countryId ?? null,
            zip: parsed.zip ?? null,
        },
        remitSameAsShipping,
        // The pair-form schema's superRefine rejects a missing/incomplete remit sub-object
        // whenever remitSameAsShipping is false, so `parsed.remit` is always populated here —
        // no need to guard against it being falsy.
        remit: remitSameAsShipping ? null : parsed.remit,
    });
}
//# sourceMappingURL=create-pair-mapper.js.map